import axios from 'axios';
import packageJson from '../../package.json';

console.log(packageJson.homepage)
const API_URL = packageJson.homepage + '/api/';
// const API_URL = 'https://leoscope.surrey.ac.uk/api/';
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
export default api;
